import { render } from "./MetadataEditor.vue?vue&type=template&id=567f91ad&scoped=true"
import script from "./MetadataEditor.vue?vue&type=script&lang=js"
export * from "./MetadataEditor.vue?vue&type=script&lang=js"

import "./MetadataEditor.vue?vue&type=style&index=0&id=567f91ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567f91ad"]])

export default __exports__